// extracted by mini-css-extract-plugin
export default {"page":"SpinnerFullPage_page__uYZSq"};